import script from "./olsale.vue?vue&type=script&setup=true&lang=js"
export * from "./olsale.vue?vue&type=script&setup=true&lang=js"

import "./olsale.vue?vue&type=style&index=0&id=d20d5886&lang=scss"

const __exports__ = script;

export default __exports__